import { Button, Card, Space, Typography } from 'antd';
import { loginWith } from '../api/client';
import { SITE } from '@nagoya-cat/shared';

const PROVIDERS = [
  { key: 'line', label: '使用 LINE 登入', className: '!bg-[#06C755] hover:!bg-[#05b34d]' },
  { key: 'google', label: '使用 Google 登入', className: '!bg-[#4285F4] hover:!bg-[#3b78e0]' },
] as const;

/** 登入頁：LINE / Google 登入（一帳號可綁多種登入方式，無公開註冊）。 */
export default function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Card className="w-[360px] shadow-md">
        <Typography.Title level={3} className="!mb-1 text-center">
          {SITE.name} 後台
        </Typography.Title>
        <Typography.Paragraph type="secondary" className="text-center">
          請選擇登入方式
        </Typography.Paragraph>
        <Space direction="vertical" className="w-full" size="middle">
          {PROVIDERS.map((p) => (
            <Button
              key={p.key}
              block
              size="large"
              className={`!border-none !text-white ${p.className}`}
              onClick={() => loginWith(p.key)}
            >
              {p.label}
            </Button>
          ))}
        </Space>
      </Card>
    </div>
  );
}
